import type { ElementType, ReactNode } from "react";
import styles from "./Container.module.css";

type ContainerWidth = "default" | "narrow" | "full";

interface ContainerProps {
  children: ReactNode;
  /** Max content width. `full` removes the cap but keeps gutters. */
  width?: ContainerWidth;
  /** Remove horizontal gutters (edge-to-edge). */
  bleed?: boolean;
  as?: ElementType;
  className?: string;
}

/** Horizontally-centered content well with consistent gutters. */
export function Container({
  children,
  width = "default",
  bleed = false,
  as: Tag = "div",
  className,
}: ContainerProps) {
  const cls = [
    styles.container,
    styles[width],
    bleed ? styles.bleed : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return <Tag className={cls}>{children}</Tag>;
}
